export const DEFAULT_DISPLAY_NAME = 'Untitled Page'
export const DEFAULT_UNIQUE_NAME = 'untitled_page'
export const MAX_PAGES = 25
export const MAX_ONLINE_IN_MENU_PAGES = 10

export const PAGES_SECTION_IN_MENU_LIST = 'pages-section-in-menu-list'
export const PAGES_SECTION_NOT_IN_MENU_LIST = 'pages-section-not-in-menu-list'
